import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { EditFormBase } from '../../../core/helper/editFormBase';
import { SessionHelper } from '../../../core/helper/sessionHelper';
import { Sustitucion } from '../../../core/models/sustitucion.model';
import { A3LCompanyService } from '../../../core/services/a3LCompany.service';
import { SustitucionService } from '../../../core/services/sustitucion.service';
import { Location } from '@angular/common';
import { A3LEmployeeService } from '../../../core/services/a3LEmployee.service';
import { A3LEmployee } from '../../../core/models/a3LEmployee.model';
import { A3LEmployeeOnITModel } from '../../../core/models/a3LEmployeeOnIT.model';
import { EmpleadosSustitucionesModel } from '../../../core/models/empleadosParaSustitucion.model';
import { Guid } from "guid-typescript";


@Component({
  selector: 'app-gestion-sustiticiones-baja-detail',
  templateUrl: './gestion-sustiticiones-baja-detail.component.html',
  styleUrls: ['./gestion-sustiticiones-baja-detail.component.css'],
  providers: [SustitucionService, A3LCompanyService, A3LEmployeeService]
})
export class GestionSustiticionesBajaDetailComponent extends EditFormBase<Sustitucion, string> implements OnInit {

  // Propiedades del panel contenedor
  panelIcon = 'people-arrows'; // Awesome icon
  panelTitle = 'Sustitución';
  panelDescription = '';
  emptyGuid = Guid.createEmpty().toString();

  private _selectedCompany: number;
  public get selectedCompany(): number {
    return this._selectedCompany;
  }
  public set selectedCompany(value: number) {
    this._selectedCompany = value;
    this.loadEmployees(value);
  }

  employeeOnIt: A3LEmployeeOnITModel;
  employeesOnIt: Array<A3LEmployeeOnITModel>;
  employees: Array<A3LEmployee>;

  constructor(
    _route: ActivatedRoute,
    _modelService: SustitucionService,
    _messageDialog: MessageDialog,
    protected _sessionHelper: SessionHelper,
    protected companyService: A3LCompanyService,
    protected employeeService: A3LEmployeeService,
    _router: Router,
    _location: Location,
  ) {
    super(_modelService, _messageDialog, _route, _router, _location, Sustitucion);
  }

  ngOnInit() {
    this.getModel();
  }

  loadEmployees(companyCode: number) {
    if (!companyCode || this.loading)
      return;

    this.loading = true;
    this.employeeService.getForSubstitution(companyCode.toString()).subscribe(
      (empleados: EmpleadosSustitucionesModel) => {

        this.employeesOnIt = empleados.EmpleadosEnIT;

        if (this.model && this.model.IdEmpleado) {
          this.employeeOnIt = this.employeesOnIt?.find(x => x.employeeId == this.model.IdEmpleado);
        }

        this.employees = empleados.Empleados;
        this.loading = false;
      },
      error => {
        console.error(error);
        this.loading = false;
      }
    );
  }

  onEmployeeOnItChanged(employeeId: any) {
    this.employeeOnIt = this.employeesOnIt?.find(x => x.employeeId == employeeId);
    this.model.IdEmpleado = employeeId;
  }

  create() {
    this.model.IdCliente = this._sessionHelper.User.IdCliente;

    this.model.FechaInicioIt = this.employeeOnIt.itStartDate;
    this.model.FechaFinIt = this.employeeOnIt.itEndDate;

    this.model.A3LItId = this.employeeOnIt.itId;
    this.model.A3LItDescription = this.employeeOnIt.itDescription;
    super.create();
  }

  update(mensaje?: string): void {

    if (this.model.A3LItId != null) {
      this.model.A3LItId = this.employeeOnIt.itId;
    }

    if (this.model.A3LItDescription != null) {
      this.model.A3LItDescription = this.employeeOnIt.itDescription;
    }

    super.update();
  }

  afterModelLoad(): void {
    if (this.model?.EmpleadoEnIt) {
      this.selectedCompany = parseInt(this.model.EmpleadoEnIt.A3LCompanyCode);
    }
    if (this.model?.EmpleadoSustituto) {
      if (this.employees.findIndex(x => x.Id == this.model.EmpleadoSustituto.A3LEmployeeId) == -1) {
        let empleadoSustituto = new A3LEmployee();

        empleadoSustituto.Id = this.model.EmpleadoSustituto.A3LEmployeeId;
        empleadoSustituto.completeName = this.model.EmpleadoSustituto.A3LCompleteName;
        empleadoSustituto.employeeCode = this.model.EmpleadoSustituto.A3LEmployeeCode;

        this.employees.push(empleadoSustituto);
      }
    }
  }

  afterModelCreated(success: boolean): void {

  }

  afterModelUpdated(success: boolean): void {
    if (success) {
      this.getModel();
    }
  }

  getModelInstance(): Sustitucion {
    return new Sustitucion();
  }

}
